import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import styles from './SimpleNavigation.module.scss';
import Logo from '../../assets/Logo.png';
const SimpleNavigation = () => {
    return (_jsx("nav", { className: styles.nav, role: "navigation", "aria-label": "Main navigation", children: _jsx("div", { className: styles.nav__container, children: _jsx(Link, { to: "/", className: styles.nav__logoWrapper, children: _jsx("img", { src: Logo, alt: "Endurance Technologies Logo", width: "50", height: "50" }) }) }) }));
};
export default SimpleNavigation;
